import { render, staticRenderFns } from "./RichmondStudio.vue?vue&type=template&id=399b15b2&scoped=true"
import script from "./RichmondStudio.vue?vue&type=script&lang=js"
export * from "./RichmondStudio.vue?vue&type=script&lang=js"
import style0 from "./RichmondStudio.vue?vue&type=style&index=0&id=399b15b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b15b2",
  null
  
)

export default component.exports